const PROTOCOLO = 'pasos-12meses-protocolo.html';
const PROMPT = 'dev/prompts/HITOS-formularios.md';
/** Los momentos que se repiten. */
const CHECKINS_PRIMER_SEMESTRE = [
    'checkin-s01',
    'checkin-s02',
    'checkin-s03',
    'checkin-s05',
    'checkin-s06',
    'checkin-s07',
    'checkin-s09',
    'checkin-s10',
    'checkin-s14',
    'checkin-m05',
];
const CHECKINS_SEGUNDO_SEMESTRE = ['checkin-m07', 'checkin-m09', 'checkin-m11'];
const TODAS_LAS_EVALUACIONES = [
    'eval-d28',
    'eval-m02',
    'eval-m03',
    'eval-d120',
    'eval-d180',
    'eval-d240',
    'eval-d300',
    'eval-d360',
];
const EVALUACIONES_CON_CALIDAD_DE_VIDA = [
    'eval-d120',
    'eval-d180',
    'eval-d240',
    'eval-d300',
    'eval-d360',
];
const SEMANAL = ['microcheck-semanal'];
/** El mensual y el ampliado de M9, que suma P9 y P10 a la misma batería. */
const MENSUALES = ['microcheck-mensual', 'microcheck-mensual-ampliado'];
function fuente(linea, texto) {
    return { archivo: PROTOCOLO, linea, texto };
}
function pendiente(hallazgo) {
    return { estado: 'pendiente', hallazgo, referencia: `${PROMPT} · ${hallazgo}` };
}
/** Una pregunta de check-in: la registra el microcheck y la proyecta su respuesta. */
function delCheckin(formularios, preguntaId) {
    return {
        estado: 'completo',
        registro: { via: 'formulario', formularios, preguntaId },
        evento: 'microcheck.answered',
        fhir: ['QuestionnaireResponse'],
        dondeVive: 'ambos',
    };
}
/** Una escala: `QuestionnaireResponse` con cada ítem y `Observation` del puntaje. */
function deEscala(formularioId, preguntaId) {
    return {
        estado: 'completo',
        registro: { via: 'formulario', formularios: [formularioId], preguntaId },
        evento: 'scale.completed',
        fhir: ['QuestionnaireResponse', 'Observation'],
        dondeVive: 'ambos',
    };
}
/**
 * Una pregunta de un cuestionario de hito (E3.25, D-01): la registra el
 * cuestionario, la anota `questionnaire.answered` y la proyecta su
 * `QuestionnaireResponse`, más el recurso del hecho cuando lo es.
 */
function delCuestionario(formularioId, preguntaId, hecho = []) {
    return {
        estado: 'completo',
        registro: { via: 'formulario', formularios: [formularioId], preguntaId },
        evento: 'questionnaire.answered',
        fhir: ['QuestionnaireResponse', ...hecho],
        dondeVive: 'ambos',
    };
}
/** La medicación: cada fila es además un `MedicationStatement`. */
function medicacionDel(formularioId) {
    return delCuestionario(formularioId, 'medicacion', ['MedicationStatement']);
}
/** Una reinternación: además, un `Encounter` de internación por cada una nueva. */
function reinternacionDel(formularioId) {
    return delCuestionario(formularioId, 'hubo-reinternacion', ['Encounter']);
}
/** Una reintervención: además, un `Procedure` con la cirugía del RFC. */
function reintervencionDel(formularioId) {
    return delCuestionario(formularioId, 'hubo-reintervencion', ['Procedure']);
}
export const CATALOGO_DE_DATOS = [
    // ══ D+0 · alta e ingreso ════════════════════════════════════════════════
    {
        id: 'consentimiento',
        nombre: 'Consentimiento informado',
        fuente: fuente(425, 'obtener consentimiento informado'),
        momentos: ['alta'],
        forma: 'aceptación de una versión del texto',
        estado: 'completo',
        registro: { via: 'captura', flujo: 'consentimiento', campo: 'version' },
        evento: 'consent.signed',
        fhir: ['Consent'],
        dondeVive: 'ambos',
    },
    {
        id: 'identidad',
        nombre: 'Datos de identidad del paciente',
        fuente: fuente(426, 'carga datos de identidad'),
        momentos: ['alta'],
        forma: 'conjunto mínimo de datos (Res. 2524/2019), cifrado',
        estado: 'completo',
        registro: { via: 'captura', flujo: 'alta', campo: 'identidad' },
        evento: 'patient.identity_checked',
        fhir: ['Patient'],
        dondeVive: 'ambos',
    },
    {
        id: 'persona-de-contacto',
        nombre: 'Persona de contacto (cuidador)',
        fuente: fuente(428, 'invita a la Persona de Contacto'),
        momentos: ['alta'],
        forma: 'invitación con el vínculo declarado',
        // Postgres ya lo tiene (`caregiver_link`); el `RelatedPerson` es de la parte
        // 2 del acceso y el alta.
        estado: 'parcial-hasta',
        etapa: 'acceso y alta, parte 2',
        hallazgo: 'D-06',
        referencia: 'dev/auditoria-datos.md · D-06 (H-23)',
        dondeVive: 'ambos',
    },
    {
        id: 'frecuencia-minima',
        nombre: 'Frecuencia mínima de interacción',
        fuente: fuente(429, 'frecuencia mínima de interacción'),
        momentos: ['alta'],
        forma: 'patrón de cadencia del plan',
        estado: 'operativo-por-diseno',
        referencia: 'ADR-005 · el plan asignado vive en Postgres; sus resultados, en FHIR',
        dondeVive: 'postgres',
    },
    {
        id: 'egreso',
        nombre: 'Fecha de egreso (día 0)',
        fuente: fuente(430, 'fecha/hora de egreso'),
        momentos: ['alta'],
        forma: 'fecha',
        estado: 'completo',
        registro: { via: 'captura', flujo: 'alta', campo: 'episodio.egresoAt' },
        evento: 'program.started',
        fhir: ['EpisodeOfCare', 'Encounter'],
        dondeVive: 'ambos',
    },
    {
        id: 'destino-al-alta',
        nombre: 'Destino al alta',
        fuente: fuente(430, 'destino al alta'),
        momentos: ['alta'],
        forma: 'domicilio, rehabilitación u otra institución',
        ...pendiente('D-04'),
        referencia: 'dev/auditoria-datos.md · D-04 (alta parte 2)',
        dondeVive: 'ambos',
    },
    {
        id: 'plan-de-ejercicios',
        nombre: 'Plan de ejercicios según diagnóstico',
        fuente: fuente(446, 'Link al plan de ejercicios'),
        momentos: ['alta'],
        forma: 'contenido asignado por fractura y cirugía',
        estado: 'parcial-hasta',
        etapa: 'E5',
        hallazgo: 'D-05',
        referencia: 'dev/auditoria-datos.md · D-05 (M12, contenidos)',
        dondeVive: 'postgres',
    },
    {
        id: 'contactos-de-emergencia',
        nombre: 'Teléfono de emergencias, médico de cabecera y urgencias habitual',
        fuente: fuente(447, 'teléfono emergencias, médico de cabecera'),
        momentos: ['alta'],
        forma: 'contactos de terceros, cifrados',
        estado: 'pendiente-de-fundacion',
        referencia: 'dev/pendientes-fundacion.md §0b · el consentimiento tiene que cubrir datos de terceros (D-04)',
        dondeVive: 'ambos',
    },
    // ══ Check-ins del primer semestre ════════════════════════════════════════
    {
        id: 'p1-tratamiento-primer-semestre',
        nombre: 'P1 · ¿Seguís con el tratamiento activo?',
        fuente: fuente(462, '¿Seguís con el tratamiento activo?'),
        momentos: CHECKINS_PRIMER_SEMESTRE,
        forma: 'Sí / No',
        ...delCheckin(SEMANAL, 'tratamiento'),
    },
    {
        id: 'p2-dolor-primer-semestre',
        nombre: 'P2 · Dolor hoy 0 a 10',
        fuente: fuente(463, 'Dolor hoy 0–10'),
        momentos: CHECKINS_PRIMER_SEMESTRE,
        forma: 'puntaje 0 a 10, no puntúa ni pinta color',
        estado: 'completo',
        registro: { via: 'formulario', formularios: SEMANAL, preguntaId: 'dolor' },
        evento: 'pain.reported',
        fhir: ['QuestionnaireResponse', 'Observation'],
        dondeVive: 'ambos',
    },
    {
        id: 'p3-ejercicios-primer-semestre',
        nombre: 'P3 · ¿Hiciste los ejercicios esta semana?',
        fuente: fuente(464, '¿Hiciste los ejercicios esta semana?'),
        momentos: CHECKINS_PRIMER_SEMESTRE,
        forma: 'Todos / A medias / No pude',
        ...delCheckin(SEMANAL, 'ejercicios'),
    },
    {
        id: 'p4-movilidad-primer-semestre',
        nombre: 'P4 · Movilidad contra la semana anterior',
        fuente: fuente(465, 'Movilidad vs semana anterior'),
        momentos: CHECKINS_PRIMER_SEMESTRE,
        forma: 'Mejor / Igual / Peor',
        ...delCheckin(SEMANAL, 'movilidad'),
    },
    {
        id: 'p5-nms-primer-semestre',
        nombre: 'P5 · Árbol básico del NMS',
        fuente: fuente(466, 'P5 NMS'),
        momentos: CHECKINS_PRIMER_SEMESTRE,
        forma: 'tres dominios del New Mobility Score, por árbol de sí/no',
        ...deEscala('nms', 'casa'),
    },
    // ══ Evaluaciones · las cuatro escalas ════════════════════════════════════
    {
        id: 'escala-nms',
        nombre: 'New Mobility Score',
        fuente: fuente(492, 'NMS (0–9)'),
        momentos: TODAS_LAS_EVALUACIONES,
        forma: '0 a 9',
        ...deEscala('nms', 'casa'),
    },
    {
        id: 'escala-cas-e',
        nombre: 'CAS-E · Escala de Movilidad Acumulada',
        fuente: fuente(492, 'CAS-E (0–6)'),
        momentos: TODAS_LAS_EVALUACIONES,
        forma: '0 a 6, autoinformado',
        ...deEscala('cas-e', 'cama'),
    },
    {
        id: 'escala-katz15',
        nombre: 'Katz-15',
        fuente: fuente(492, 'Katz-15 (0–15)'),
        momentos: TODAS_LAS_EVALUACIONES,
        forma: '0 a 15, quince ítems de sí/no',
        ...deEscala('katz-15', 'item-01'),
    },
    {
        id: 'escala-eq5d5l',
        nombre: 'EQ-5D-5L',
        fuente: fuente(577, 'Primera aplicación del EQ-5D-5L'),
        momentos: EVALUACIONES_CON_CALIDAD_DE_VIDA,
        forma: 'cinco dimensiones 1 a 5 y VAS 0 a 100',
        ...deEscala('eq5d5l', 'vas'),
    },
    // ══ D+28 · cuestionario ampliado ═════════════════════════════════════════
    {
        id: 'medicacion-d28',
        nombre: 'Medicación actual con dosis · D+28',
        fuente: fuente(488, 'Medicación actual con dosis'),
        momentos: ['eval-d28'],
        forma: 'droga del catálogo, potencia en mg e intervalo en horas, por fila',
        ...medicacionDel('cuestionario-d28'),
    },
    {
        id: 'reinternacion-d28',
        nombre: 'Reinternación en los últimos 30 días · D+28',
        fuente: fuente(489, '¿Reinternación en últimos 30 días?'),
        momentos: ['eval-d28'],
        forma: 'sí o no; si sí, fecha y dónde',
        ...reinternacionDel('cuestionario-d28'),
    },
    {
        id: 'reintervencion-d28',
        nombre: 'Reintervención quirúrgica · D+28',
        fuente: fuente(490, '¿Reintervención quirúrgica?'),
        momentos: ['eval-d28'],
        forma: 'sí o no; si sí, fecha y cirugía del catálogo del RFC',
        ...reintervencionDel('cuestionario-d28'),
    },
    {
        id: 'acceso-a-actividades-d28',
        nombre: 'Acceso a actividades propuestas · D+28',
        fuente: fuente(491, 'Acceso a actividades propuestas'),
        momentos: ['eval-d28'],
        // Definición de Fundación del 26/09: no es una pregunta, se deriva del clic
        // en el vínculo de cada ejercicio y de un check voluntario de si lo hizo.
        // Los contenidos no existen todavía: no se inventa una pregunta para taparlo.
        forma: 'derivado: consulta del vínculo de cada ejercicio y check voluntario de realizado',
        estado: 'parcial-hasta',
        etapa: 'E5',
        hallazgo: 'D-05',
        referencia: 'definición de Fundación del 26/09/2026 · dev/auditoria-datos.md D-05',
        dondeVive: 'postgres',
    },
    // ══ D+120 ════════════════════════════════════════════════════════════════
    {
        id: 'medicacion-d120',
        nombre: 'Medicación actual · D+120',
        fuente: fuente(578, 'Medicación actual, reinternaciones y reintervenciones en 4 meses'),
        momentos: ['eval-d120'],
        forma: 'droga del catálogo, potencia en mg e intervalo en horas, por fila',
        ...medicacionDel('cuestionario-d120'),
    },
    {
        id: 'reinternacion-d120',
        nombre: 'Reinternaciones en 4 meses · D+120',
        fuente: fuente(578, 'reinternaciones'),
        momentos: ['eval-d120'],
        forma: 'sí o no; si sí, fecha y dónde de cada una',
        ...reinternacionDel('cuestionario-d120'),
    },
    {
        id: 'reintervencion-d120',
        nombre: 'Reintervenciones en 4 meses · D+120',
        fuente: fuente(578, 'reintervenciones en 4 meses'),
        momentos: ['eval-d120'],
        forma: 'sí o no; si sí, fecha y cirugía de cada una',
        ...reintervencionDel('cuestionario-d120'),
    },
    // ══ D+180 ════════════════════════════════════════════════════════════════
    {
        id: 'medicacion-d180',
        nombre: 'Medicación actual · D+180',
        fuente: fuente(623, 'Medicación actual, reinternaciones y reintervenciones en 6 meses'),
        momentos: ['eval-d180'],
        forma: 'droga del catálogo, potencia en mg e intervalo en horas, por fila',
        ...medicacionDel('cuestionario-d180'),
    },
    {
        id: 'reinternacion-d180',
        nombre: 'Reinternaciones en 6 meses · D+180',
        fuente: fuente(623, 'reinternaciones'),
        momentos: ['eval-d180'],
        forma: 'sí o no; si sí, fecha y dónde de cada una',
        ...reinternacionDel('cuestionario-d180'),
    },
    {
        id: 'reintervencion-d180',
        nombre: 'Reintervenciones en 6 meses · D+180',
        fuente: fuente(623, 'reintervenciones en 6 meses'),
        momentos: ['eval-d180'],
        forma: 'sí o no; si sí, fecha y cirugía de cada una',
        ...reintervencionDel('cuestionario-d180'),
    },
    {
        id: 'adherencia-d180',
        nombre: 'Adherencia total al programa · D+180',
        fuente: fuente(624, 'Adherencia total al programa'),
        momentos: ['eval-d180'],
        forma: 'derivado: contactos respondidos sobre intentados',
        estado: 'completo',
        registro: {
            via: 'derivacion',
            funcion: 'calcularAdherencia',
            desde: ['checkin.completed', 'checkin.missed'],
        },
        evento: 'checkin.completed',
        // Derivado y operativo por diseño (ADR-008): el registro clínico no lo ve.
        fhir: [],
        dondeVive: 'postgres',
    },
    // ══ Check-ins del segundo semestre ═══════════════════════════════════════
    {
        id: 'p1-tratamiento-segundo-semestre',
        nombre: 'P1 · ¿Seguís con el tratamiento activo? (segundo semestre)',
        fuente: fuente(676, '¿Seguís con el tratamiento activo?'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'Sí / No',
        ...delCheckin(MENSUALES, 'tratamiento'),
    },
    {
        id: 'p2-dolor-segundo-semestre',
        nombre: 'P2 · Dolor promedio de la semana',
        fuente: fuente(677, 'Dolor promedio esta semana'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'puntaje 0 a 10, no puntúa ni pinta color',
        estado: 'completo',
        registro: { via: 'formulario', formularios: MENSUALES, preguntaId: 'dolor' },
        evento: 'pain.reported',
        fhir: ['QuestionnaireResponse', 'Observation'],
        dondeVive: 'ambos',
    },
    {
        id: 'p3-ejercicios-segundo-semestre',
        nombre: 'P3 · ¿Realizás los ejercicios indicados?',
        fuente: fuente(678, '¿Realizás los ejercicios indicados?'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'Todos / A medias / No pude',
        ...delCheckin(MENSUALES, 'ejercicios'),
    },
    {
        id: 'p4-movilidad-segundo-semestre',
        nombre: 'P4 · Movilidad general',
        fuente: fuente(679, 'Movilidad general'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'Sí, todas / La mayoría / Pocas / Casi ninguna',
        ...delCheckin(MENSUALES, 'movilidad'),
    },
    {
        id: 'p5-nms-segundo-semestre',
        nombre: 'P5 · Árbol básico del NMS (segundo semestre)',
        fuente: fuente(680, 'Árbol NMS básico'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'tres dominios del New Mobility Score, por árbol de sí/no',
        ...deEscala('nms', 'casa'),
    },
    {
        id: 'p6-calidad-de-vida',
        nombre: 'P6 · Calidad de vida general',
        fuente: fuente(681, 'Calidad de vida general'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'Muy buena / Buena / Regular / Mala',
        ...delCheckin(MENSUALES, 'calidad-de-vida'),
    },
    {
        id: 'p7-participacion-social',
        nombre: 'P7 · Actividades sociales o recreativas',
        fuente: fuente(682, '¿Pudiste retomar actividades sociales o recreativas'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'Sí / A medias / Todavía no',
        ...delCheckin(MENSUALES, 'participacion'),
    },
    {
        id: 'p8-autonomia',
        nombre: 'P8 · Desplazarse fuera de casa sin depender de alguien',
        fuente: fuente(683, '¿Podés desplazarte solo/a fuera de tu casa'),
        momentos: CHECKINS_SEGUNDO_SEMESTRE,
        forma: 'Sí, solo o sola / Necesito que me lleven / No salgo',
        ...delCheckin(MENSUALES, 'autonomia'),
    },
    {
        id: 'p9-marcha-sostenida',
        nombre: 'P9 · Caminar más de 20 minutos seguidos',
        fuente: fuente(732, '¿Podés caminar más de 20 minutos seguidos'),
        momentos: ['checkin-m09'],
        forma: 'Sí / A veces / No',
        ...delCheckin(['microcheck-mensual-ampliado'], 'marcha'),
    },
    {
        id: 'p10-animo',
        nombre: 'P10 · Estado de ánimo',
        fuente: fuente(733, '¿Cómo está tu estado de ánimo este mes?'),
        momentos: ['checkin-m09'],
        forma: 'Muy bien / Bien / Regular / Bajo · dato, no disparador',
        ...delCheckin(['microcheck-mensual-ampliado'], 'animo'),
    },
    // ══ D+240 · autonomía ════════════════════════════════════════════════════
    {
        id: 'compras-o-tramites-d240',
        nombre: 'Compras o trámites básicos · D+240',
        fuente: fuente(703, '¿Podés realizar compras o trámites básicos solo/a?'),
        momentos: ['eval-d240'],
        forma: 'Sí / Con ayuda / No',
        ...delCuestionario('cuestionario-d240', 'compras-o-tramites'),
    },
    {
        id: 'transporte-d240',
        nombre: 'Transporte público o auto · D+240',
        fuente: fuente(704, '¿Podés usar transporte público'),
        momentos: ['eval-d240'],
        forma: 'Sí / Con dificultad / No',
        ...delCuestionario('cuestionario-d240', 'transporte'),
    },
    {
        id: 'actividades-grupales-d240',
        nombre: 'Actividades grupales, religiosas o recreativas · D+240',
        fuente: fuente(705, '¿Participás de actividades grupales'),
        momentos: ['eval-d240'],
        forma: 'Sí / A veces / No',
        ...delCuestionario('cuestionario-d240', 'actividades-grupales'),
    },
    // ══ D+300 ════════════════════════════════════════════════════════════════
    {
        id: 'medicacion-d300',
        nombre: 'Actualización de medicación · D+300',
        fuente: fuente(749, 'Actualización de medicación'),
        momentos: ['eval-d300'],
        forma: 'droga del catálogo, potencia en mg e intervalo en horas, por fila',
        ...medicacionDel('cuestionario-d300'),
    },
    {
        id: 'reinternacion-d300',
        nombre: 'Reinternaciones en los últimos 4 meses · D+300',
        fuente: fuente(750, '¿Reinternaciones o reintervenciones en los últimos 4 meses?'),
        momentos: ['eval-d300'],
        forma: 'sí o no; si sí, fecha y dónde de cada una',
        ...reinternacionDel('cuestionario-d300'),
    },
    {
        id: 'reintervencion-d300',
        nombre: 'Reintervenciones en los últimos 4 meses · D+300',
        fuente: fuente(750, 'reintervenciones en los últimos 4 meses'),
        momentos: ['eval-d300'],
        forma: 'sí o no; si sí, fecha y cirugía de cada una',
        ...reintervencionDel('cuestionario-d300'),
    },
    {
        id: 'autonomia-desplazamientos-d300',
        nombre: 'Autonomía en desplazamientos · D+300',
        fuente: fuente(751, 'Nivel de autonomía en desplazamientos'),
        momentos: ['eval-d300'],
        forma: 'Sí / Con dificultad / No (propuesta: la de D+240, sin enunciado del protocolo)',
        ...delCuestionario('cuestionario-d300', 'desplazamientos'),
    },
    {
        id: 'autonomia-actividades-cotidianas-d300',
        nombre: 'Autonomía en actividades cotidianas · D+300',
        fuente: fuente(751, 'actividades cotidianas'),
        momentos: ['eval-d300'],
        forma: 'Sí / Con ayuda / No (propuesta: la de D+240, sin enunciado del protocolo)',
        ...delCuestionario('cuestionario-d300', 'actividades-cotidianas'),
    },
    {
        id: 'autonomia-participacion-social-d300',
        nombre: 'Autonomía en participación social · D+300',
        fuente: fuente(751, 'participación social (3 preguntas)'),
        momentos: ['eval-d300'],
        forma: 'Sí / A veces / No (propuesta: la de D+240, sin enunciado del protocolo)',
        ...delCuestionario('cuestionario-d300', 'participacion-social'),
    },
    // ══ D+360 · cierre anual ═════════════════════════════════════════════════
    {
        id: 'medicacion-d360',
        nombre: 'Medicación actual contra la del egreso · D+360',
        fuente: fuente(795, 'Medicación actual vs al egreso'),
        momentos: ['eval-d360'],
        forma: 'droga del catálogo, potencia e intervalo; el equipo ve qué se agregó, retiró o cambió',
        ...medicacionDel('cuestionario-d360'),
    },
    {
        // La base de la comparación de D+360 (decisión de Cowork, informada a
        // Fundación): se carga en el paso 2 del alta, con el mismo grupo del catálogo.
        id: 'medicacion-al-egreso',
        nombre: 'Medicación al egreso · base de la comparación de D+360',
        fuente: fuente(795, 'Medicación actual vs al egreso'),
        momentos: ['alta'],
        forma: 'droga del catálogo, potencia en mg e intervalo en horas, por fila; opcional',
        ...medicacionDel('medicacion-al-egreso'),
    },
    {
        id: 'total-reinternaciones-reintervenciones-d360',
        nombre: 'Total de reinternaciones y reintervenciones en 12 meses · D+360',
        fuente: fuente(796, 'Total de reinternaciones y reintervenciones en 12 meses'),
        momentos: ['eval-d360'],
        forma: 'derivado de las respuestas anteriores, sin repetir; se muestra y se confirma',
        // No se vuelve a preguntar: se deriva de lo que contó en cada cuestionario,
        // sin contar dos veces lo que las ventanas del protocolo repiten, y D+360 se
        // lo muestra y le pregunta si falta alguno (`otra-reinternacion`). Cada
        // hecho vive en FHIR como Encounter o Procedure; el total, en Postgres.
        estado: 'completo',
        registro: {
            via: 'derivacion',
            funcion: 'hechosDelAnio',
            desde: ['questionnaire.answered', 'clinical_fact.reported'],
        },
        evento: 'clinical_fact.reported',
        fhir: [],
        dondeVive: 'postgres',
    },
    {
        id: 'reintegracion-trabajo-d360',
        nombre: 'Reintegración al trabajo · D+360',
        fuente: fuente(797, 'Nivel de reintegración: trabajo'),
        momentos: ['eval-d360'],
        forma: 'puntaje 0 a 3',
        ...delCuestionario('cuestionario-d360', 'reintegracion-trabajo'),
    },
    {
        id: 'reintegracion-social-d360',
        nombre: 'Reintegración a actividades sociales · D+360',
        fuente: fuente(797, 'actividades sociales'),
        momentos: ['eval-d360'],
        forma: 'puntaje 0 a 3',
        ...delCuestionario('cuestionario-d360', 'reintegracion-social'),
    },
    {
        id: 'reintegracion-recreativa-d360',
        nombre: 'Reintegración a actividades recreativas · D+360',
        fuente: fuente(797, 'recreativas (escala 0–3 por dominio)'),
        momentos: ['eval-d360'],
        forma: 'puntaje 0 a 3',
        ...delCuestionario('cuestionario-d360', 'reintegracion-recreativa'),
    },
    {
        id: 'adherencia-d360',
        nombre: 'Adherencia total al programa en 12 meses · D+360',
        fuente: fuente(798, 'Adherencia total al programa: % check-ins respondidos en 12 meses'),
        momentos: ['eval-d360'],
        forma: 'derivado: contactos respondidos sobre intentados',
        estado: 'completo',
        registro: {
            via: 'derivacion',
            funcion: 'calcularAdherencia',
            desde: ['checkin.completed', 'checkin.missed'],
        },
        evento: 'checkin.completed',
        fhir: [],
        dondeVive: 'postgres',
    },
    // ══ Fuera del calendario ═════════════════════════════════════════════════
    {
        id: 'aviso-del-paciente',
        nombre: 'Aviso del paciente: caída, dolor agudo, movilidad, medicación, herida u otro',
        fuente: {
            archivo: 'casos-de-uso.html',
            linea: 709,
            texto: 'Tipo de evento o síntoma',
        },
        momentos: ['fuera-de-calendario'],
        forma: 'categoría de lista cerrada, severidad percibida y el momento en que pasó',
        // E3.25 · PR 3 (D-03): el evento en Postgres y una `Observation` por aviso en
        // el registro clínico, con la categoría como código, la severidad como
        // `component` y el momento en que pasó como `effectiveDateTime`.
        estado: 'completo',
        registro: { via: 'evento', clave: 'categoria' },
        evento: 'patient.event_reported',
        fhir: ['Observation'],
        dondeVive: 'ambos',
    },
    {
        id: 'semaforo',
        nombre: 'Semáforo del paciente',
        fuente: {
            archivo: 'dev/adr/ADR-008-codificacion-escalas.md',
            linea: 1,
            texto: 'ADR-008',
        },
        momentos: TODAS_LAS_EVALUACIONES,
        forma: 'derivado de las cuatro escalas: verde, amarillo o rojo',
        estado: 'operativo-por-diseno',
        referencia: 'ADR-008 · el semáforo no se escribe en FHIR; se ve en la aplicación y en los reportes',
        dondeVive: 'postgres',
    },
];
/** El dato, por su id. Tira si no está: un id del catálogo es una constante. */
export function datoDelProtocolo(id) {
    const dato = CATALOGO_DE_DATOS.find((candidato) => candidato.id === id);
    if (!dato)
        throw new Error(`El dato "${id}" no está en el catálogo del protocolo.`);
    return dato;
}
/** Los datos que siguen pendientes, agrupados por hallazgo. */
export function pendientesPorHallazgo(datos = CATALOGO_DE_DATOS) {
    const salida = {};
    for (const dato of datos) {
        if (dato.estado !== 'pendiente')
            continue;
        salida[dato.hallazgo] = [...(salida[dato.hallazgo] ?? []), dato.id];
    }
    return salida;
}
//# sourceMappingURL=catalogo-de-datos.js.map